import React, { useEffect, useState } from "react";
import {
  Typography,
  Grid,
  Tooltip,
  IconButton,
  Button,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import moment from "moment";
import userSupportService from "../../../../services/UserSupportService";

import {
  UserAccountDTO,
  UserFeedStats,
} from "@beable/roster-backend-client-v1";
import { Autorenew } from "@mui/icons-material";

interface UserFeedDataProps {
  user: UserAccountDTO;
  siteId: number;
}

export default function UserFeedData({ user, siteId }: UserFeedDataProps) {
  const [feedStats, setFeedStats] = useState<UserFeedStats | undefined>();

  useEffect(() => {
    const fetchUserData = async () => {
      const statsResp = await userSupportService.getUserFeedStats(
        user.id,
        siteId,
        user.primaryLanguage
      );
      setFeedStats(statsResp);
    };
    fetchUserData();
  }, [user, siteId]);

  const updateFeed = async (user: UserAccountDTO) => {
    const result = await userSupportService.regenerateUserFeed(
      user.id,
      siteId,
      user.primaryLanguage
    );
    if (result) {
      alert("Feed update request submitted successfully");
    } else {
      alert("There was an error submitting your request.");
    }
  };

  function UpdateFeedButton() {
    return (
      <Button
        variant="contained"
        color="primary"
        aria-label="reprovision"
        onClick={() => updateFeed(user)}
        data-testid="btn-reprovision"
        startIcon={<Autorenew fontSize="small" />}
      >
        Update User Feed
      </Button>
    );
  }

  return (
    <Grid container>
      <Grid size={11}>
        <Typography sx={{ paddingBottom: "5px" }}>
          {UpdateFeedButton()}
        </Typography>
      </Grid>
      <Grid size={1}>
        <Tooltip
          title={
            <>
              <Typography component="span" sx={{ fontWeight: "bold" }}>Lessons delivered:</Typography>{" "}
              displayed in the hero panel for any length of time <br />
              <Typography component="span" sx={{ fontWeight: "bold" }}>Lessons expired:</Typography>{" "}
              includes: a)completed lessons and b) lesson expired after
              displaying in the hero panel for 7 days
              <br />
              <Typography component="span" sx={{ fontWeight: "bold" }}>Lessons queued:</Typography> in the
              user's queue and will be delivered once currently displayed
              lessons expire
              <br />
              <br />
              *delivered lesson count is generally 3 more than the expired count
            </>
          }
        >
          <IconButton size="large">
            <InfoIcon />
          </IconButton>
        </Tooltip>
      </Grid>
      <Grid size={12}>
        {feedStats ? (
          <>
            <Typography>
              {`Lessons delivered: ${feedStats.lifetimeDelivered}`}
            </Typography>
            <Typography>{`Lessons expired: ${feedStats.expired}`}</Typography>
            <Typography>{`Lessons queued: ${feedStats.queuedLessons}`}</Typography>
            <Typography>
              {`Feed last changed on ${moment(feedStats.lastGeneratedDt).format("MM/DD/YYYY H:m:s")} with ${feedStats.lastRecordCount} lessons`}
            </Typography>
          </>
        ) : (
          <Typography>No feed data</Typography>
        )}
      </Grid>
    </Grid>
  );
}
